import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  isMedshorts;
  isMedigi;

  constructor() {}

  ngOnInit() {
    this.isMedshorts =
      environment.clientDomains.medshortsDomain === window.location.host;
    this.isMedigi =
      environment.clientDomains.medigiDomain === window.location.host;
  }
}
